import React, { useEffect, useMemo, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Home from "./Home";
import { canAccess, loadPermissions } from "../permissions";
import { getTokenPayload } from "../auth";
import {
  Box,
  Skeleton,
  Stack,
  Paper,
  Toolbar,
  AppBar,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  TableContainer,
} from "@mui/material";

export default function AuthLanding() {
  const navigate = useNavigate();
  const location = useLocation();
  const redirectedOnceRef = useRef(false);

  const isLoggedIn = useMemo(() => {
    const payload = getTokenPayload();
    console.log("Token payload:", payload);
    return !!payload;
  }, []);

  useEffect(() => {
    if (!isLoggedIn) return;
    let cancelled = false;
    const ensurePermissions = async () => {
      console.log("Starting to load permissions...");
      try {
        await loadPermissions({ preferServerEvaluation: true });
        console.log("Permissions loaded.");
      } catch (err) {
        console.error("Error loading permissions", err);
      }
      if (cancelled || redirectedOnceRef.current) return;
      console.log("Calling firstAccessibleRoute");
      const route = firstAccessibleRoute();
      console.log("firstAccessibleRoute returned:", route);
      if (route && route !== location.pathname) {
        redirectedOnceRef.current = true;
        navigate(route, { replace: true });
      }
    };
    ensurePermissions();
    return () => {
      cancelled = true;
    };
  }, [isLoggedIn, navigate, location.pathname]);

  return (
    <>
      <Box>
        {/* Navbar */}
        <AppBar position="static" sx={{ mb: 3, bgcolor: "#ffffff" }}>
          <Toolbar>
            <Skeleton
              variant="text"
              width={120}
              height={30}
              sx={{ bgcolor: "grey.700" }}
            />
          </Toolbar>
        </AppBar>

        <Box sx={{ px: 3 }}>
          {/* Header */}
          <Skeleton variant="text" width="30%" height={40} sx={{ mb: 2 }} />

          {/* Buttons Row */}
          <Stack direction="row" spacing={2} sx={{ mb: 3 }}>
            <Skeleton variant="rectangular" width={100} height={36} />
            <Skeleton variant="rectangular" width={100} height={36} />
            <Skeleton variant="rectangular" width={100} height={36} />
          </Stack>

          {/* Table Skeleton */}
          <Paper elevation={1}>
            <TableContainer sx={{ maxHeight: "70vh" }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {Array.from({ length: 5 }).map((_, idx) => (
                      <TableCell
                        key={idx}
                        sx={{
                          backgroundColor: "#17479e",
                          color: "white",
                          fontWeight: 600,
                          position: "sticky",
                          top: 0,
                          zIndex: 3,
                        }}
                      >
                        <Skeleton variant="text" width="80%" />
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.from({ length: 6 }).map((_, rowIndex) => (
                    <TableRow key={rowIndex}>
                      {Array.from({ length: 5 }).map((_, cellIndex) => (
                        <TableCell key={cellIndex}>
                          <Skeleton variant="text" width="100%" />
                        </TableCell>
                      ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Box>
      </Box>
    </>
  );
  // return <Home />;
}

function firstAccessibleRoute() {
  console.log("Inside firstAccessibleRoute");
  // Prefer general pages; fallback to DB Data if that's all the user has
  const ordered = [
    ["ROUTE_BOOKLIST", "/booklist"],
    ["ROUTE_BOOKDETAILS", "/bookdetails"],
    ["ROUTE_BOOKFORM", "/bookform"],
    ["ROUTE_COURSE_BOOK_MAPPING", "/courseBookMapping"],
    ["ROUTE_UPDATES", "/updates"],
    ["ROUTE_COUPONS", "/Coupons"],
    ["ROUTE_BOOKSCONTENT", "/booksContent"],
    ["ROUTE_BOOKSFILES", "/booksfiles"],
    ["ROUTE_DB_DATA", "/dbdata"],
    ["DB_DATA_BUTTON", "/dbdata"],
    ["ADMIN_BUTTON", "/admin/dashboard"],
  ];

  for (const [key, path] of ordered) {
    console.log(key);
    console.log(`Checking access for key: ${key}`);
    if (canAccess(key)) {
      console.log(`Access granted for key: ${key}, redirecting to: ${path}`);
      return path;
    }
  }
  return null;
}
